var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import PropTypes from "prop-types";
import { IndexRedirect, PartialRoute, withPartialRoute } from "@irati/utils/history/routing";
import { injectIntl } from "@irati/utils/lang";
import AppContainer from "@irati/ui/src/AppContainer";
import { AccountWrapper } from "@irati/ui/src/Account";
import { greys } from "@irati/ui/src/global/colors";
import SideNavigation from "@irati/ui/src/Navigation/SideNavigation";
import authentication from "@irati/auth";
import getMenuItems from "../components/AccountMenu/menuItems";
import getMobileMenuItems from "../components/AccountMenu/mobileMenuItems";
import UpdateUser from "../containers/UpdateUser";
import UpdateContactPreferences from "../containers/UpdateContactPreferences";
import UpdateUserPassword from "../containers/UpdateUserPassword";
import UpdateUserPayment from "../containers/UpdateUserPayment";
import PerksGOLinkedCards from "../containers/PerksGOLinkedCards";
import Security from "../containers/Security";
import CategoriesCustomisation from "../containers/Customisation";
var Settings = function (_a) {
    var match = _a.match;
    return (React.createElement(React.Fragment, null,
        React.createElement(IndexRedirect, { to: "password" }),
        React.createElement(PartialRoute, { match: match.url, path: "/contact", component: UpdateContactPreferences, title: "Contact Preferences" }),
        React.createElement(PartialRoute, { match: match.url, path: "/password", component: UpdateUserPassword, title: "Update Password" }),
        React.createElement(PartialRoute, { match: match.url, path: "/security", component: Security, title: "Security" }),
        React.createElement(PartialRoute, { match: match.url, path: "/payment", component: UpdateUserPayment, title: "Update Payment Details" }),
        React.createElement(PartialRoute, { match: match.url, path: "/linkedcards/:action?/:uuid?", component: PerksGOLinkedCards, title: "My Linked Cards" }),
        React.createElement(PartialRoute, { match: match.url, path: "/customisation/categories", component: CategoriesCustomisation, title: "Customise my interests" })));
};
var AccountRoutes = /** @class */ (function (_super) {
    __extends(AccountRoutes, _super);
    function AccountRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountRoutes.prototype.render = function () {
        var _a = this.props, path = _a.path, formatMessage = _a.formatMessage;
        var isManagedExternally = authentication.user().isManagedExternally;
        var menuItems = getMenuItems({
            showFidel: !!authentication.apps("platform.fidel"),
            showCustomisation: !!authentication.apps("perks"),
            isManagedExternally: isManagedExternally,
            platformApp: this.context.apps.PLATFORM
        });
        var mobileMenuItems = getMobileMenuItems({
            showFidel: !!authentication.apps("platform.fidel"),
            showCustomisation: !!authentication.apps("perks"),
            isManagedExternally: isManagedExternally
        });
        var accountProps = {
            indexRedirect: "profile",
            MobileMenu: function () { return React.createElement(SideNavigation, { links: mobileMenuItems }); },
            mobileBack: formatMessage({ id: "account.mobile.label" }),
            mobileBackLink: "/",
            Menu: function () { return React.createElement(SideNavigation, { links: menuItems }); },
            usesNewSideNav: true
        };
        return (React.createElement(AppContainer, { mainBackground: greys.white },
            React.createElement(AccountWrapper, __assign({}, accountProps),
                React.createElement(IndexRedirect, { match: { url: path }, to: "/" }),
                React.createElement(PartialRoute, { match: path, path: "/profile", component: UpdateUser, title: "Update Details" }),
                React.createElement(PartialRoute, { match: path, path: "/settings", component: Settings }))));
    };
    AccountRoutes.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return AccountRoutes;
}(Component));
export default withPartialRoute(injectIntl(AccountRoutes));
